"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_VOLUME = void 0;
var DEFAULT_VOLUME = exports.DEFAULT_VOLUME = 0.8;